module.exports = __webpack_public_path__ + "static/media/IMG_0003.d559b726.jpg";